import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ChangeDetectionStrategy
} from "@angular/core";

import { LogoService } from "../../avatar/logo.service";
import { ImageUploadComponent } from "../image-upload.component";
import { ImageUploadModalReturnData } from "../image-upload-interface";

@Component({
  selector: "onsip-logo-upload",
  templateUrl: "./logo-upload.component.html",
  styleUrls: ["./logo-upload.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class LogoUploadComponent {
  /** input from the child image cropper. Gets the image in png;base64 form from the image cropper */
  @ViewChild("imageUpload") imageUpload!: ImageUploadComponent;

  /** flag if parent component is using the upload through a dialog or not */
  // the upload button is only shown when the component is using a dialog so for
  // non-dialog component using the upload, you will have to hook up the confirmUpload() function in
  // that parent component
  @Input() hasDialog = false;

  /** flag to let the image upload component whether to wrap the image in an avatar frame or not */
  @Input() hasFrame = false;

  /** Output emitter to send info to the parent component */
  @Output() logoChange = new EventEmitter<ImageUploadModalReturnData>();

  /** flag if user has deleted their current logo from the image uploader */
  hasDeletedLogo = false;

  constructor(public logoService: LogoService) {}

  deleteCurrent(): void {
    this.hasDeletedLogo = true;
  }

  confirmUpload(): void {
    const imageResponse: ImageUploadModalReturnData = {
      doSave: true,
      image: ""
    };
    if (this.imageUpload && this.imageUpload.croppedImage) {
      imageResponse.image = this.imageUpload.croppedImage || "";
    } else {
      // save changes if user does delete avatar at the upload screen
      imageResponse.doSave = this.hasDeletedLogo;
    }
    if (imageResponse.doSave && imageResponse.image !== undefined) {
      this.logoService.saveLogo(imageResponse.image);
    }

    this.logoChange.emit(imageResponse);
  }
}
